module.exports = __webpack_public_path__ + "static/img/Updates version 2.5.0.29fae6d.png";